app.controller("donationCtrl", [
  "$scope",
  "$location",
  "$localStorage",
  "getSiteDetails",
  "checkUser",
  function ($scope, $location, $localStorage, getSiteDetails, checkUser) {
    checkUser.checkLoginAndVerify(
      () => {},
      () => {
        $localStorage.redirect = window.location.href;
        $location.path("/purchaseLogin");
      }
    );

    let microsite = JSON.parse($localStorage.microsite);
    let siteConfig = microsite.microsite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    getSiteDetails
      .getDonatePageElements(siteConfig.micrositeID)
      .then((result) => {
        $scope.donatePageElements = result.content;
      })
      .catch((err) => {
        $scope.donatePageElements = [];
      });
  },
]);
